import BuyerJourneySagas from "./BuyerJourneySagas";
import SupplierJourneySagas from "./SupplierJourneySagas";
import { all, fork } from 'redux-saga/effects'

export default function* rootSaga() {
	yield all([
		BuyerJourneySagas(),
		SupplierJourneySagas()
	]);
}